import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './app/App';
import { AutoMeasurePage } from './automeasure/AutoMeasure';
import { parseHandoff } from './handoff';
import { Recorder } from './recorder/Recorder';
import { pending } from './storage/pending';

// Nessun router: tre pagine in tutto. /recorder è lo strumento della Fase 0 (bundle di replay); il flusso che parte da Quick si riconosce dal
// codice di avvio nell'indirizzo (o da una sua misura rimasta a metà); tutto il resto, la radice compresa, è la misura senza tocchi con l'utente
// di EMS (Dim separata da Quick): l'indirizzo semplice del sito porta direttamente lì.
const path = location.pathname;
const fromQuick = !path.startsWith('/misura') && (parseHandoff(location.search) !== null || pending.load() !== null);
const isMeasure = !path.startsWith('/recorder') && !fromQuick;

// La misura è in modalità scura: i colori cambiano dalle variabili di index.css, e la barra del browser prende il nero del fondo.
if (isMeasure) {
  document.documentElement.classList.add('scuro');
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#000000');
}

const root = createRoot(document.getElementById('root')!);
const page = path.startsWith('/recorder') ? <Recorder /> : isMeasure ? <AutoMeasurePage /> : <App />;
root.render(<StrictMode>{page}</StrictMode>);
